import React from 'react'

import { Helmet } from 'react-helmet'

import Header from '../../components/header'
import Footer from '../../components/footer'
import Whatsapp from '../../components/whatsapp'
import './direito-tributrio.css'

const DireitoTributrio = (props) => {
  return (
    <div className="direito-tributrio-container10">
      <Helmet>
        <title>Direito-Tributrio - Adv. Wanderson H Cavalari - Cuiabá</title>
        <meta
          name="description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
        <meta
          property="og:title"
          content="Direito-Tributrio - Adv. Wanderson H Cavalari - Cuiabá"
        />
        <meta
          property="og:description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
      </Helmet>
      <div className="direito-tributrio-container11">
        <main className="direito-tributrio-container12">
          <div className="direito-tributrio-container13">
            <Header rootClassName="headerroot-class-name13"></Header>
            <div className="direito-tributrio-container14">
              <div className="direito-tributrio-frame46">
                <span className="direito-tributrio-text10">
                  ÁREA DE ATUAÇÃO
                </span>
                <span className="direito-tributrio-text11">Direito</span>
                <span className="direito-tributrio-text12">Tributário</span>
                <span className="direito-tributrio-text13">
                  O direito tributário na advocacia envolve a orientação e
                  representação de indivíduos e empresas em questões
                  relacionadas à legislação fiscal, planejamento tributário,
                  contencioso administrativo e judicial.
                </span>
              </div>
              <div className="direito-tributrio-container15">
                <span className="direito-tributrio-text14">
                  <span>Fale Comigo</span>
                </span>
                <span className="direito-tributrio-text16 Content">
                  Quer saber mais sobre esta área de atuação? Mande-me uma
                  mensagem para introduzirmos esta questão
                </span>
                <iframe
                  src="https://whc-dun.vercel.app/email"
                  scrolling="no"
                  className="direito-tributrio-iframe"
                ></iframe>
              </div>
            </div>
          </div>
          <div className="direito-tributrio-container16">
            <div className="direito-tributrio-container17">
              <div className="direito-tributrio-frame86">
                <div className="direito-tributrio-container18">
                  <div className="direito-tributrio-container19">
                    <span className="direito-tributrio-text17">
                      <span>Recuperação de Pis e Cofins</span>
                      <br></br>
                    </span>
                    <span className="direito-tributrio-text20">
                      <span>
                        Uma ação de recuperação de PIS (Programa de Integração
                        Social) e COFINS (Contribuição para o Financiamento da
                        Seguridade Social) é uma medida legal que uma empresa
                        pode tomar para reaver valores pagos indevidamente ou a
                        maior dessas contribuições ao longo do tempo.
                      </span>
                      <br></br>
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/trib-pis-cofins.jpg"
                    loading="eager"
                    className="direito-tributrio-image1"
                  />
                </div>
                <div className="direito-tributrio-container20">
                  <div className="direito-tributrio-container21">
                    <span className="direito-tributrio-text23">
                      <span>Isenção de Imposto de renda para doença grave</span>
                      <br></br>
                    </span>
                    <span className="direito-tributrio-text26">
                      <span>
                        A isenção de imposto de renda para pessoas portadoras de
                        doenças graves é um direito previsto na legislação
                        brasileira. Essa isenção é concedida sobre os
                        rendimentos recebidos pela pessoa portadora da doença,
                        sejam eles salários, aposentadorias, pensões, entre
                        outros.
                      </span>
                      <br></br>
                      <span>
                        De acordo com a legislação vigente, algumas doenças são
                        passíveis de isenção de imposto de renda sobre os
                        rendimentos recebidos por pessoas portadoras dessas
                        enfermidades. Essa isenção está prevista na Lei
                        7.713/1988 e suas alterações. As doenças que conferem o
                        direito à isenção de imposto de renda são:
                      </span>
                      <br></br>
                      <span>
                        - AIDS (Síndrome da Imunodeficiência Adquirida)
                      </span>
                      <br></br>
                      <span>
                        -
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span>Alienação Mental</span>
                      <br></br>
                      <span>
                        -
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span>Cardiopatia Grave</span>
                      <br></br>
                      <span>
                        -
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span>Cegueira</span>
                      <br></br>
                      <span>
                        -
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span>Contaminação por Radiação</span>
                      <br></br>
                      <span>
                        -
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span>
                        Doença de Paget em estados avançados (Osteíte
                        Deformante)
                      </span>
                      <br></br>
                      <span>
                        -
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span>Doença de Parkinson</span>
                      <br></br>
                      <span>
                        -
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span>Esclerose Múltipla</span>
                      <br></br>
                      <span>
                        -
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span>Espondiloartrose Anquilosante</span>
                      <br></br>
                      <span>
                        -
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span>Fibrose Cística (Mucoviscidose)</span>
                      <br></br>
                      <span>
                        -
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span>Hanseníase</span>
                      <br></br>
                      <span>
                        -
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span>Hepatopatia Grave</span>
                      <br></br>
                      <span>
                        -
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span>Nefropatia Grave</span>
                      <br></br>
                      <span>
                        -
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span>Neoplasia Maligna</span>
                      <br></br>
                      <span>
                        -
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span>Paralisia Irreversível e Incapacitante</span>
                      <br></br>
                      <span>
                        -
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span>Tuberculose Ativa</span>
                      <br></br>
                      <span>
                        Essas são as doenças atualmente listadas na legislação
                        como passíveis de isenção de imposto de renda. No
                        entanto, é importante ressaltar que a lista pode ser
                        alterada por meio de atualizações na legislação ou em
                        normas complementares.
                      </span>
                      <br></br>
                      <br></br>
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/trib-isencao-doenca.jpg"
                    loading="eager"
                    className="direito-tributrio-image2"
                  />
                </div>
                <div className="direito-tributrio-container22">
                  <img
                    alt="image"
                    src="/trib-contencioso.jpg"
                    loading="eager"
                    className="direito-tributrio-image3"
                  />
                  <div className="direito-tributrio-container23">
                    <span className="direito-tributrio-text81">
                      Contencioso administrativo e judicial
                    </span>
                    <span className="direito-tributrio-text82">
                      <span>
                        Defesas em processos administrativos perante a União,
                        Estados, Distrito Federal e Municipal.
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>
                        Atuação em processos judiciais, por meio de defesas em
                        execuções fiscais, ajuizamento de ações declaratórias de
                        inexistência de relação jurídico-tributária, anulatórias
                        de débito fiscal e impetração de mandados de segurança.
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <br></br>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer rootClassName="footerroot-class-name7"></Footer>
          <Whatsapp></Whatsapp>
        </main>
      </div>
    </div>
  )
}

export default DireitoTributrio
